import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface SidebarState {
  messagesCount: number;
}

const initialState: SidebarState = {
  messagesCount: 0,
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: initialState,
  reducers: {
    setMessagesCount: (state, action: PayloadAction<number>) => {
      state.messagesCount = action.payload;
    },
    reset: () => initialState,
  },
});

export const { setMessagesCount, reset } = sidebarSlice.actions;

export default sidebarSlice.reducer;
